(() => {
  const revealTargets = document.querySelectorAll('main .shopify-section, .product-card, .legacy-care-panel');
  revealTargets.forEach((el, index) => { el.dataset.legacyReveal = ''; el.style.transitionDelay = `${Math.min(index % 4, 3) * 65}ms`; });
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
    }), { threshold: .08, rootMargin: '0px 0px -6% 0px' });
    revealTargets.forEach(el => io.observe(el));
  } else revealTargets.forEach(el => el.classList.add('is-visible'));
  if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
    addEventListener('pointermove', e => { document.body.style.setProperty('--legacy-x', `${e.clientX}px`); document.body.style.setProperty('--legacy-y', `${e.clientY}px`); }, { passive:true });
  }
})();
